// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"ba0306d1","644":"4a819ba3","833":"b7f3d6cb"}[chunkId] + ".chunk.js";
};